import { FC } from 'react';
import { PropsWithClassName } from '@/types/PropsWithClassName';
import { cn } from '@/utils/classNames.ts';

type MessageProps = {
  message: string;
  isMine?: boolean;
};

const Message: FC<PropsWithClassName<MessageProps>> = ({ message, isMine = false, className }) => {
  return (
    <div
      className={cn(
        'p-6 italic',
        {
          'bg-primary-400 bg-opacity-30': isMine,
          'bg-gray-200': !isMine,
        },
        className
      )}
    >
      {message}
    </div>
  );
};

export default Message;
